import { Component } from '@angular/core';
import { AuthService, AuthResponse } from '../../service/auth/auth.service';

/**
 * Componente para mostrar la información del perfil del usuario
 */
@Component({
  selector: 'app-profile',
  imports: [],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.css',
})
export class ProfileComponent {
  /**
   * Datos del usuario actual
   */
  public user: string | null = null;

  /**
   * Constructor del componente
   * @param authService Servicio de autenticación para obtener datos del usuario
   */
  constructor(private authService: AuthService) {
    this.getUser();
  }

  /**
   * Obtiene el nombre del usuario y lo convierte a mayúsculas
   * @returns El nombre del usuario en mayúsculas
   */
  getUser(): string {
    const user = this.authService.getCurrentUser();
    if (user)
      return (this.user = user.fullname
        .toLowerCase()
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' '));
    return '';
  }
}
